import { createStore } from 'vuex'
import AuthService from "../services/auth.service";
import mutations from './mutations';
import actions from './actions.js';
import getters from './getters.js';

//vuex main fle
export default createStore({
  state: {
    user: null,
    loggedIn: false
  },
  mutations: mutations,
  getters: getters,
  actions: actions,
  modules: {
  }
})
